<template>
  <div class="newsPage">
    <div class="top">
        <img src="../img/logo.png" alt="">
      <div class="line"></div>
      <img src="../img/min_title.png" alt="" class="imgRight">
    </div>
    <div class="main">
      <div class="title">媒体聚焦 • 新闻中心</div>
      <div class="hotspotCon">
        <div class="firstHot" v-if="newsList.length>0" @click="toDetail(newsList[0])">
          <img
            :src="'http://conference2019.hanban.org/upload/'+newsList[0].thumb"
            v-if="newsList.length>0"
            v-on:load="loadImg('.firstHot', 0, $event)"
            :class="{ 'toWidth': newsList[0]['toWidth'] == true}"
            alt
          />
          <div class="firstTitle">{{newsList[0].title}}</div>
        </div>
        <div class="newsListRight">
          <ul>
            <li v-for="(newsItem, index) in newsListArray" :key="index">
                <span @click="toDetail(newsItem)" :title="newsItem.title"> {{newsItem.title}}</span>
                <!-- <router-link :to="{path:'/pcpage/detailpage/newsdetail',query: {id: newsItem.id}}" active-class="activeLink">
                    {{newsItem.title}}
                </router-link> -->
            </li>
        </ul>
          <div class="moreNews">
            <router-link to="/pcpage/detailpage/newslist" active-class="activeLink">
                <span>{{ $t("message.more") }} ></span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news",
  data: function() {
    return {
      newsList: []
    };
  },
  computed: {
    newsListArray() {
      return this.newsList.slice(1, this.newsList.length-1)
    },
    language() {
        return this.$i18n.locale
    }
  },
  methods: {
          // 根据图片宽高比动态显示不同样式
    loadImg (dom, i, e) {
        var wrapperWidth = $(dom).width()
        var wrapperHeight = $(dom).height()
        if(e.target.naturalWidth/e.target.naturalHeight - (wrapperWidth/wrapperHeight) > 0){
            this.$set(this.newsList[i], 'toWidth', false)
        $(e.target).css('transform','translateX(-'+(e.target.width-wrapperWidth)/2+'px)')
        }else {
            this.$set(this.newsList[i], 'toWidth', true)
            $(e.target).css('height', 'auto')
            var radio = wrapperWidth/e.target.naturalWidth
            $(e.target).css('transform','translateY(-'+(e.target.height*radio-wrapperHeight)/2+'px)')
        }
    },
    getAllList() {
      this.$utils
        .get("hotspot/api/getAllList", {
          lang: 'cn'
        })
        .then(res => {
          this.newsList = res.data.data.list;
        });
    },
    toDetail(item) {
        window.open(item.link)
    }
  },
    watch: {
      // 监听切换语言
      language (newval, old) {
          //this.getAllList()
      }
    },
  mounted() {
    this.getAllList()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.newsPage {
  .top {
    margin-left: 55px;
    padding-top: 30px;
    .line {
      display: inline-block;
      width: 1px;
      height: 80px;
      background-color: rgba(255, 255, 255, 0.5);
      margin: 0 45px;
      vertical-align: super;
    }
  }
  .main {
    // float: right;
    // margin-right: 140px;
    margin-left: 240px;
    .title {
      font-size: 60px;
      color: #f3bc65;
      font-weight: bold;
      margin: 28px 120px;
    }
    .hotspotCon {
        margin-top: 46px;
        margin-left: 120px;
        .firstHot {
        width: 768px;
        height: 480px;
        position: relative;
        display: inline-block;
        overflow: hidden;
        cursor: pointer;
        img {
            height: 100%;
        }
        .toWidth {
            width: 100%;
            height: auto;
        }
        .firstTitle {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            padding-top: 32px;
            padding-left: 2%;
            box-sizing: border-box;
            height: 120px;
            opacity: 0.8;
            font-size: 30px;
            color: #fff;
            line-height: 36px;
            text-align: left;
            white-space: initial;


        }
        }
        .firstHot:hover {
            .firstTitle {
                color: #f3bc65;
            }
        }
        .newsListRight {
            display: inline-block;
            width: 361px;
            vertical-align: top;
            margin-left: 48px;
            ul {
                height: 461px;
            }
            li {
                margin-bottom: 45px;
                font-size: 22px;
                line-height: 1.4;
                color: #fff;
                list-style-type:disc;
                cursor: pointer;   
                white-space: initial;
                // overflow : hidden;
                // text-overflow: ellipsis;
                // display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                a {
                    color: #fff;
                    text-decoration: none;
                }
            }
            .moreNews a:hover,li span:hover {
                color: #f3bc65;
                
            }
            .moreNews {
                margin-top: 55px;
                text-align: right;
                font-size: 30px;
                cursor: pointer;
                a {
                    color: #fff;
                    text-decoration: none;
                }
            }
        }
    }

  }
}
@media screen and (min-width: 1240px) and (max-width: 1280px) {
.newsPage {
    .top {
        padding-top: 15px;
        margin-left: 30px;
        img:first-child {
            width: 127px;
        }
        .line {
            display: inline-block;
            width: 1px;
            height: 49px;
            background-color: rgba(255, 255, 255, 0.5);
            margin: 0 30px;
            vertical-align: super;
        }
        .imgRight {
            width: 294px;
        }
    }
    .main {
        margin-left: 28px;
        .title {
            font-size: 36px;
            margin: 28px 0;
        }
        .hotspotCon {
            width: 900px;
            margin: 28px 0;
            .firstHot {
                width: 528px;
                height: 340px;
                .firstTitle {
                    font-size: 20px;
                    padding-top: 60px;
                    line-height: 1.2;
                }
            }
            .newsListRight {
                width: 320px;
                ul {
                    height: 310px;
                }
                li {
                    font-size: 16px;
                    margin-bottom: 30px;
                }
                .moreNews {
                    font-size: 20px;
                }
            }
        }
    }
}

  
}
@media screen and (min-width: 1280px) and (max-width: 1600px) {
.newsPage {
    .top {
        padding-top: 15px;
        margin-left: 30px;
        img:first-child {
            width: 127px;
        }
        .line {
            display: inline-block;
            width: 1px;
            height: 49px;
            background-color: rgba(255, 255, 255, 0.5);
            margin: 0 30px;
            vertical-align: super;
        }
        .imgRight {
            width: 294px;
        }
    }
    .main {
        margin-left: 28px;
        .title {
            font-size: 36px;
            margin: 28px 0;
        }
        .hotspotCon {
            width: 1065px;
            margin: 28px 0;
            .firstHot {
                width: 625px;
                height: 390px;
                .firstTitle {
                    font-size: 24px;
                }
            }
            .newsListRight {
                width: 320px;
                ul {
                    height: 370px;
                }
                li {
                    font-size: 18px;
                    margin-bottom: 30px;
                }
                .moreNews {
                    font-size: 24px;
                }
            }
        }
    }
}

  
}
@media screen and (max-width: 1680px) {
.newsPage {
    .main {
        margin-left: 0;
        float: left;
        .title {
            margin: 28px 60px;
        }
        .hotspotCon {
            margin: 28px 0 28px 60px;
        }
    }
}

  
}
</style>
